import { useRouter } from "next/router"
import { UnderlinedButton } from "../../Buttons/UnderlinedButton"
import { Container } from "../../Container/Container"
import ViewsIcon from "../../../public/images/icons/views.svg";
import { IconContainer } from "../../Buttons/IconContainer";
import useTranslation from "next-translate/useTranslation";
import cls from 'clsx';
import { MediaListItem } from "@jconradi/tutu-porn-api-client/src/users";
import { MediaType } from "@jconradi/tutu-porn-api-client/src/media";

export const WatchMore = ({ mediaListItem }: { mediaListItem: MediaListItem } ) => {
    const router = useRouter();
    const { t } = useTranslation('common');

    return (
        <Container topL={false} topR={false} className={cls("p-1 sm:p-[20px] mt-[4px] sm:mt-[16px]", {
            ['mt-[4px] sm:mt-[8px]']: mediaListItem.mediaType != MediaType.Gallery,
            ['mt-[16px] sm:mt-[20px]']:   mediaListItem.mediaType == MediaType.Gallery
        })}>
            <UnderlinedButton className="mx-auto" onClick={() => { router.push(`/watch/${mediaListItem.slug}`) }}>
                <div className="flex flex-row gap-x-2 items-center justify-center">
                <p>{t('seeMoreLikeThis')}</p>
                <ViewsIcon className="w-8 h-8 text-white" />
                </div>
            </UnderlinedButton>
        </Container>
    )
}